var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dis.length > 0)?_c('div',{staticClass:"di-grid-container"},_vm._l((_vm.dis),function(di,index){return _c('DIGridItem',{key:'di-'+index,attrs:{"di":di,"index":index},on:{"diSelected":_vm.diSelected}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }